// CustomButton.js
import { Button } from '@mantine/core';
import React from 'react';

const CustomButton = ({
  bgColor,
  title,
  className,
  onClick,
  type,
  isdisabled,
  icon
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={isdisabled}
      className={className}
      style={{
        height: '45px',
        backgroundColor: isdisabled ? 'lightgray' : bgColor,
        display: 'flex',
        justifyContent: 'center',
        gap: '8px'
      }}
      radius="xl"
    >
      {icon && <span>{icon}</span>}
      <span>{title}</span>
    </Button>
  );
};

export default CustomButton;
